/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clipboard': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<g id="Layer_1"><path pid="0" d="M19.5 4c-.3 0-.5-.2-.5-.5C19 2.1 17.9 1 16.5 1h-1C14.1 1 13 2.1 13 3.5c0 .3-.2.5-.5.5H5v27h22V4h-7.5zM12 6h.5C13.9 6 15 4.9 15 3.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5C17 4.9 18.1 6 19.5 6h.5v2h-8V6zm13 23H7V6h3v4h12V6h3v23z"/><path pid="1" d="M10 14h12v2H10zM10 19h12v2H10zM10 24h12v2H10z"/></g>'
  }
})
